module.exports = __webpack_public_path__ + "img/bannerOtrosServicios.d5ce36c6.jpg";